
import home from "@/components/home/home";
import money from "@/components/home/money";
import resultDialog from "@/components/publicComponents/resultDialog";
import center from "@/components/personalCenter/personalCenter";
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'

import { IsValid, getXAccountUrl2, getSStore } from "@js/public/mUtils";
export default {
components: {
Tabbar,
TabbarItem,
resultDialog,
"my-home": home,
"my-money": money,
"my-center": center,
},
data() {
return {
tabbarNum: null,
trainShow: false,
oldNumber: 0,
openResult: {},
openFlag: false,
colorShow: false,
mesStyle: { width: "300", height: "290" },
};
},
created() {},
mounted() {
if (getSStore("xhcWl") === "0") {
this.trainShow = true;
} else {
this.trainShow = false;
}
this.eventBus.$on("changeMenu", (val) => {
this.updateTab(val);
});
},
activated() {
if (getSStore("xhcWl") === "0") {
this.trainShow = true;
} else {
this.trainShow = false;
}
},
watch: {
tabbarNum: function(val, oldVal) {
this.oldNumber = oldVal;
},
"$store.state.tabBarNumber"(newVal) {
this.oldNumber = newVal;
},
},
methods: {
changeTabbar(val) {
switch (val) {
case 0:
this.toPage("/comeIn/home", {});
this.sa.track("first_page_button_click", {
first_module: "首页",
});
break;
case 1:
this.toPage("/comeIn/money/all", {});
this.sa.track("first_page_button_click", {
first_module: "理财",
});
break;
case 2:
if (this.trainShow === true) {
this.$http.post("/customer/state", {}).then((res) => {
if (res.code === 0) {
if (!res.body.state) {

if (res.body.certValid == "10") {
const result = {
title: "您还未开户",
content: "完成实名绑卡后，即可进行下一步哦",
description: "",
icon: "warn",
buttons: [
{
type: "primary",
text: "去实名",
link: "/registerTwo?action=register&source=wx",
active: true,
},
{
type: "default",
text: "关闭",
link: "-2",
active: false,
},
],
};
this.mesStyle = { width: "300", height: "290" };
this.openResult = result;
this.openFlag = true;
this.colorShow = true;
this.updateTab();
} else if (res.body.certValid == "11") {
const result = {
title: "提示",
content: res.body.message,
description: "",
icon: "warn",
buttons: [
{
type: "primary",
text: "确定",
link: "-2",
active: true,
},
],
};
console.log(77162);
this.mesStyle = { width: "300", height: "230" };
console.log(this.mesStyle);
this.openResult = result;
this.openFlag = true;
this.colorShow = true;
this.updateTab();
} else {
const result = {
title: "去完善个人信息",
content: res.body.message,
description: "",
icon: "warn",
buttons: [
{
type: "primary",
text: "去完善",
link: "/personal",
active: true,
},
{
type: "default",
text: "关闭",
link: "-2",
active: false,
},
],
};
this.mesStyle = { width: "300", height: "290" };
this.openResult = result;
this.openFlag = true;
this.colorShow = true;
this.updateTab();
}
} else {
this.colorShow = false;
const srcUrl = getXAccountUrl2("", "0");
window.location.href = srcUrl;
}
}
});


} else {
this.toPage("/comeIn/personalCenter", {});
}

break;
case 3:
this.toPage("/comeIn/personalCenter", {});
break;
}
},
updateTab(val) {
console.log(9988);
this.sa.track("first_page_button_click", {
first_module: "我的页面",
});
this.$nextTick(() => {
if (getSStore("xhcWl") === "0") {
this.trainShow = true;
} else {
this.trainShow = false;
}
if (this.trainShow === true && val === 2) {
val = this.oldNumber;
}
if (this.trainShow === false && val === 3) {
val = 3;
}
if (this.colorShow === true) {
console.log(this.oldNumber, 887);
val = this.oldNumber;
}
setTimeout(() => {
this.tabbarNum = val;
this.colorShow = false;
}, 10);
});
},
},
};



// WEBPACK FOOTER //
// ./src/components/home/comeIn.vue